import { Client, Device } from 'shared/types';

export const PIN_CODE_FOR_DELIVERY = 'pinCodeDel';

export enum userSessionTypes {
  GUEST = 'guest',
  LOGGED_IN = 'logged_in',
}

export enum platformNames {
  NYKAA = 'nykaa',
  MEN = 'men',
}

export enum standardErrorMessages {
  SOMETHING_WRONG = 'Something went wrong!',
  OOPS = 'Oops! Something went wrong...',
}

export const PRODUCT_ADDED_TO_CART = 'Item added to cart';
export enum deviceTypes {
  M_SITE = 'msite',
  M_WEB = 'mweb',
}

export enum variantTypes {
  SIZE = 'SIZE',
  SHADE = 'SHADE',
  SIMPLE = 'SIMPLE',
  BUNDLE = 'BUNDLE',
}

export const CURRENCY = 'INR';

export enum BOOLEAN_STRINGS {
  FALSE = 'false',
}
export const EU_PRIVACY = 'euPrivacy';
export const CONTINENT_CODE = 'continentCode';
export const X_CONTINENT_CODE = 'x-continent-code';

export const COUNTRY_CODE = 'countryCode';
export const X_COUNTRY_CODE = 'x-country-code';

export const REGION_HEADER = 'cloudfront-viewer-country-region';

export const REGION_HEADER_COUNTRY = 'cloudfront-viewer-country';

export const PRODUCT_ADDED_TO_WISHLIST = 'Product has been added to Wishlist.';
export const PRODUCT_REMOVED_FORM_WISHLIST =
  'Product has been removed from Wishlist.';

export const EU_CONTINENT_CODE = 'eu';

export const defaultClient: Client = {
  device: Device.WEB,
};

export const NEW_REVIEW_COOKIE = 'N_RVWS';
export enum ELEMENT_SIZE {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export const noop = () => {};
export const HTML_LANG = 'en';

export const DEFAULT_LANGUAGE = 'en';

export const contentLang = 'content-lang';

export const PRODUCT_CARD_ACTION = 'productCardAction';
export const PRODUCT_CARD_CLICKED = 'productCardClicked';
export const CAV_ACTION = 'customerAlsoViewed';
export const CAB_ACTION = 'customerAlsoBought';
export const PLP_SORTING = 'plpSorting';
export const PLP = 'PLP';
export const PDP = 'PDP';
export const HLP = 'HLP';
export const CLICK = 'click';
export const ADD_TO_CART = 'addToCart';
export const VRN_NUDGE_SHOWN = 'vrnNudgeShown';
export const BEST_SELLER_PAGE = 'bestSellerListingPage';

export const SHADES = 'Shades';
export const NOTIFY = 'Notify';
export const PLP_FILTER_TRACKING = 'plpFilterChange';
export const PLP_SORT_TRACKING = 'plpSortChange';
export const SEARCH_COMPLETE_TRACKING = 'search_complete';
export const LISTING_COMPLETE_TRACKING = 'listing_complete';
export const SYSTEM = 'system';
export const FILTER_AND_SORT = 'filterAndSort';
export const CATEGORY_FILTER = 'category_filter';
export const LANG_HI = 'hi';
export const NO_OFFER_MESSAGE = 'no_message';
export const NO_OFFER_ID = 'no_offer_id';
export const SPEED_PERCEPTION_LOAD = 'speedPerceptionTag_load';
export const SPEED_PERCEPTION_CLICK = 'speedPerceptionTag_click';

export const NO_QUERY_EXPANSION_TERM = 'no_query_expansion_term';
export const NO_QUERY_EXPANSION_TYPE = 'no_query_expansion_type';
export const ADD_TO_BAG_TEXT = 'Add to Bag';

export const goTopTop = 'goToTop';

export const EXP_AB_AUTOFILL = 'EXP_AB_AUTOFILL';

export const HOMEPAGE_PAGE_TYPE = 'mweb-homepage';

export const GOOGLE_API_KEY = 'key';
export const FILTER_KEY_REGEX = /_filter$/;
export const FILTER_APPLIED = 'filter_applied';
export const TRACK_PRICE_REVEAL = 'price_revealed';
export const FILTER_CLICKED = 'filter_clicked';
export const FILTER_CLEARED = 'filter_cleared';
export const TRACK_CLEAR_ALL = 'clearAllCTA';
export const TRACK_DISCARD_FILTERS = 'popUpDiscardCTA';
export const TRACK_APPLY_FILTERS = 'pageApplyCTA';
export const TRACK_APPLY_FILTER_VIA_POPUP = 'popUpApplyCTA';
export const TRACK_BACK_CLICK = 'pageBack';
export const DEFAULT_RECOMMENDATION_ALGOS = {
  cav: '',
  cab: '',
  cav_brand_category: '',
  more_from_category: '',
};

export const RECO_WIDGETS = {
  cav: 'cav',
  cab: 'cab',
  viewSimilarProduct: 'view_similar_product',
  moreFromCategory: 'more_from_category',
};
export const RECO_EXP = {
  moreFromCategory: 'More from category',
  customerAlsoViewed: 'Customers also viewed',
  customerAlsoBought: 'Customers also bought',
};
export const recoWidgetLoadEvent = 'reco_widget_load';

export const H_WIDGET_DESIGN = 'horizontal_slider';
export const UNAUTHORIZE_ERROR_CODE = 401;
export const OFFER_API_ERR_MESSAGE = 'Error in fetch offer api';
export const SIZE_CLICKED_EVENT = 'sizeClicked';
export const SHADE_CLICKED_EVENT = 'shadeClicked';
export const DYNAMIC_FOOTER_LINK_API_ERR_MESSAGE =
  'Error in Fetch Dynamic footer Links api';
export const MINI = 'mini';

export const interactionLocation = {
  productPage: 'productDetailPage',
  homePage: 'homePage',
  productListingPage: 'categoryListingPage',
  searchListingPage: 'searchListingPage',
  wishlistPage: 'wishlistPage',
  otherPage: 'otherPage',
};

export const AUTH_BANNER_TEXT = 'Login/Signup';
export const APP_DOWNLOAD_BANNER_TEXT = 'App Download Banner';
export const ACCOUNT = {
  topBar: 'myAccount_topBar',
  hamburger: 'myAccount_hamburger',
  default: 'myAccount',
};
export const LOGIN_CLICK_EVENT = 'login_signup_click';
export const OFFER_COUPON_LOADS = 'offer_coupon_loads';

export const CART_NUDGE_CLICKED = 'cart_nudge_clicked';
export const CART_NUDGE_CLOSED = 'cart_nudge_closed';
export const NUDGE_TITLE_TEXT = 'Items in your bag';
export const NUDGE_TITLE_TEXT_1 = 'Item in your bag';
export const NUDGE_POSITION = 49;
export const NUDGE_DEFAULT_POSITION = 0;

export const SHOW_SMART_BANNER = 'show_smart_banner';
export const HIDE_SMART_BANNER = 'hide_smart_banner';

export const ATTRIBUTE_INSTALL_OFFER = 'install_offer';
export const IOC_VALUE = 'IOC_VALUE';
export const IOC_EXPIRATION_TIME = 'IOC_EXPIRATION_TIME';
export const PDP_THIRD_FOLD = 'pdp_third_fold_loaded';
export const PDP_SECTION_EXPANDED = 'pdp_section_expanded';
export const PDP_SECOND_FOLD_LOADED = 'pdp_second_fold_loaded';
export const BEST_PRICE_API_RECEIVED = 'best_price_api_received';
export const ONLY_TAGS = 'ONLY_TAGS';
export const ONLY_RATINGS = 'ONLY_RATINGS';
export const TAGS_AND_RATING = 'TAGS_AND_RATING';
export const NO_TAG = 'no tag';
export const NykaaNowImg: Record<platformNames, string> = {
  [platformNames.NYKAA]:
    'https://images-static.naikaa.com/media/wysiwyg/uiTools/2025-8/Nykaa_Now_Logo.svg',
  [platformNames.MEN]:
    'https://images-static.naikaa.com/media/wysiwyg/uiTools/2025-8/Nykaa_Now_Logo.svg',
};
export const BOTTOMSHEET = 'bottomSheet';
export const CTA = 'cta';
export const AFFILIATE_STORAGE_KEYS = {
  PDP: 'affiliateLinkCoachmarkPDP',
  PLP: 'affiliateLinkCoachmark',
};

export const AFFILIATE_PAGE_TYPES = {
  PDP: 'pdp',
  CATEGORY: 'category',
};
export const ATTRIBUTE_CUSTOMER_SEGMENT = 'cust_premium_segment';
